import TYPES from '../../types';

// Domain
import { InvestmentEntity } from '../../domain/entities/investment-entity';
import { InvestmentRepository } from '../../domain/repository/investment-repository';
import { StateManager } from '../../domain/state/state-manager';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import Query from '@/modules/shared/domain/use-cases/query';

@Injectable()
export default class SearchInvestmentsQuery extends Query<Promise<Array<InvestmentEntity>>> {
  @Inject(TYPES.CATALOG_KUSPIT_INVESTMENT_STATE_MANAGER)
  private readonly state_manager!: StateManager;

  @Inject(TYPES.CATALOG_KUSPIT_INVESTMENT_REPOSITORY)
  private readonly repository!: InvestmentRepository

  internalExecute(): Promise<Array<InvestmentEntity>> {
    return new Promise((resolve, reject) => {
      if (!this.state_manager.state.loaded) {
        this.repository.execute()
          .then((items) => {
            this.state_manager.patch({ items, loaded: true });
            resolve(items);
          })
          .catch(reject);
      } else {
        resolve(this.state_manager.state.items);
      }
    });
  }
}
